import { Component } from '@angular/core';
import { AccountSetupHelperService } from '../../account-setup-helper.service';

@Component({
  selector: 'app-hub-legal-business-details-step',
  templateUrl: './hub-legal-business-details-step.component.html',
  styleUrls: ['./hub-legal-business-details-step.component.css'],
})
export class HubLegalBusinessDetailsStepComponent {
  

  constructor(public accountSetupHelperService: AccountSetupHelperService) {}

  get isCustomRefund() {
    return this.accountSetupHelperService.wizardData.hubInput.hubBusinessLegalDetails.refundPeriod === 'custom';
  }

  isFormValid(): boolean {
    return (
      !!this.accountSetupHelperService.wizardData.hubInput.hubBusinessLegalDetails.contactEmail &&
      !!this.accountSetupHelperService.wizardData.hubInput.hubBusinessLegalDetails.businessAddress &&
      (this.accountSetupHelperService.wizardData.hubInput.hubBusinessLegalDetails.refundPeriod !== 'custom' || !!this.accountSetupHelperService.wizardData.hubInput.hubBusinessLegalDetails.customDays)
    );
  }

}
